var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrench(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.992,
    height: 48.449,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2474"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2473"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1792",
    fill: "#5f40d4",
    d: "M0 .007L22.342.001l.014 48.443-22.342.006z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1793",
    fill: "#f0f0f0",
    d: "M22.28.007L44.622.001l.014 48.443-22.342.006z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1794",
    fill: "#ff505c",
    d: "M44.636.007L66.978.001l.014 48.443-22.342.006z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrench);
export default __webpack_public_path__ + "static/media/french.03cb658d917aa15dd27fb028cfc2eb98.svg";
export { ForwardRef as ReactComponent };